import { doubanRanking } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function DoubanRanking() {
  return (
    <section id="douban" className="w-full bg-background-100 px-4 py-10 md:px-6 md:py-14">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          eyebrow="Douban Score"
          title="豆瓣高分排行榜精选"
          desc="汇总读者口碑与长评讨论，评分和评价人数双维度筛选，适合看重叙事与完成度的读者。"
          actionText="完整豆瓣高分榜"
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {doubanRanking.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 md:p-5"
            >
              <div className="flex w-14 shrink-0 flex-col items-center justify-center rounded-lg bg-accent-100 py-2.5">
                <span className="font-heading text-xl font-bold text-accent-800">{item.score}</span>
                <span className="text-[10px] font-medium text-accent-700">评分</span>
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="font-heading text-sm font-bold text-foreground-400">No.{item.rank}</span>
                  <h3 className="truncate font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                </div>
                <p className="mt-1 flex flex-wrap items-center gap-x-2 text-xs text-foreground-500">
                  <span>{item.genre}</span>
                  <span className="text-background-400">·</span>
                  <span>{item.votes}人评价</span>
                </p>
                <p className="mt-2 line-clamp-1 text-sm text-foreground-700">{item.quote}</p>
              </div>

              <i className="ri-arrow-right-s-line hidden shrink-0 text-xl text-foreground-400 sm:block" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}